import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../i18n';
import useHeaderScroll from '../../hooks/useHeaderScroll';
import useHeaderSettings from '../../hooks/useHeaderSettings';
import LanguageSelector from '../../locales/LanguageSelector';
import TopBar from './navbar/TopBar';
import NavMenu from './navbar/NavMenu';
import MobileNavDrawer from './navbar/MobileNavDrawer';
import './navbar/Navbar.css';
import { DEFAULT_BRAND_LOGO } from '../../config/api';

const Header = () => {
  const { t } = useTranslation();
  useHeaderScroll();

  const {
    officeEmail,
    officeNumber,
    logoUrl,
    facebookLink,
    whatsappLink,
    wechatLink,
    callLink,
  } = useHeaderSettings();

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const logoSrc = logoUrl || DEFAULT_BRAND_LOGO;
  const phoneHref = callLink ? `tel:${callLink}` : '/contact';

  const toggleSearch = () => {
    setIsSearchOpen((current) => !current);
  };

  return (
    <>
      <header className="header tps-navbar">
        <TopBar
          officeEmail={officeEmail}
          facebookLink={facebookLink}
          whatsappLink={whatsappLink}
          wechatLink={wechatLink}
          callLink={callLink}
        />

        <div className="middle_bar">
          <div className="container">
            <div className="middle_bar_inner tps-navbar__middle">
              <div className="logo tps-navbar__logo-desktop">
                <Link to="/" className="light_mode_logo">
                  <img src={logoSrc} alt="TPS logo" />
                </Link>
                <Link to="/" className="dark_mode_logo">
                  <img src={logoSrc} alt="TPS logo" />
                </Link>
              </div>

              <Link to="/" className="tps-navbar__brand">
                <img
                  className="tps-navbar__brand-image tps-navbar__brand-image--light"
                  src={logoSrc}
                  alt="TPS logo"
                />
                <img
                  className="tps-navbar__brand-image tps-navbar__brand-image--dark"
                  src={logoSrc}
                  alt="TPS logo"
                />
              </Link>

              <nav className="mainnav" aria-label="Main navigation">
                <NavMenu variant="desktop" />
              </nav>

              <div className="tps-navbar__actions">
                <div className="phone tps-navbar__phone">
                  <a href={phoneHref} aria-label={t('CallUs')}>
                    <i className="fa fa-phone" aria-hidden="true" />
                  </a>
                  <div className="tps-navbar__phone-text">
                    <span className="tps-navbar__phone-label">{t('CallUs')}</span>
                    <a href={phoneHref} className="phn_number">
                      {officeNumber}
                    </a>
                  </div>
                </div>

                <div className="tps-navbar__lang-desktop">
                  <LanguageSelector />
                </div>

                <div className="header_search tps-navbar__search" onClick={toggleSearch}>
                  <button
                    type="button"
                    className="form-control-submit"
                    aria-label={t('Search...')}
                  >
                    <i className="ion-ios-search" />
                  </button>
                </div>

                <div
                  id="open_search"
                  className={`tps-navbar__search-panel${
                    isSearchOpen ? ' active' : ''
                  }`}
                >
                  <form
                    className="search_form"
                    onSubmit={(event) => event.preventDefault()}
                  >
                    <input
                      type="text"
                      name="search"
                      className="keyword form-control"
                      placeholder={t('Search...')}
                    />
                    <button type="submit" className="form-control-submit">
                      <i className="ion-ios-search" />
                    </button>
                  </form>
                </div>

                <button
                  className="tps-navbar__menu-toggle"
                  type="button"
                  aria-label="Open menu"
                  aria-expanded={isMobileNavOpen}
                  aria-controls="offcanvasHome"
                  onClick={() => setIsMobileNavOpen(true)}
                >
                  <i className="ion-android-menu" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      <MobileNavDrawer
        isOpen={isMobileNavOpen}
        onClose={() => setIsMobileNavOpen(false)}
        logoUrl={logoUrl}
        callLink={callLink}
        officeNumber={officeNumber}
      />
    </>
  );
};

export default Header;
